import TextField from '@app/src/components/Ui/TextField'
import { useProviderReport } from '@app/src/pages/Questionnaire/Provider/ProviderReportContext'
import type { RequestItem } from '@app/src/types/resourceExplorer'
import { InputAdornment, Stack } from '@mui/material'
import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { DeviationIndicator } from '../../DeviationIndicator'

type NumberQuestionFieldWithDeviationProps = {
  name: string
  requestItem: RequestItem
  disabled?: boolean
  hasError?: boolean
  error?: string
  hasAppliedSuggestion: boolean
}

const NumberQuestionFieldWithDeviation: React.FC<NumberQuestionFieldWithDeviationProps> = ({
  name,
  requestItem,
  disabled,
  hasError,
  error,
  hasAppliedSuggestion,
}) => {
  const { previouslyRespondedQuestions } = useProviderReport()
  const { register, clearErrors, control } = useFormContext()

  const { formatMessage } = useIntl()
  const selectedValue = useWatch<string>({ control: control, name })
  const answersToThisQuestion =
    previouslyRespondedQuestions?.filter(p => p.requestItem.questionId === requestItem.questionId) ?? []

  return (
    <Stack direction="row">
      <TextField
        required
        onWheelCapture={(e): void => {
          ;(e.target as HTMLInputElement).blur()
        }}
        inputRef={register}
        name={name}
        label={formatMessage({ id: 'reporting.questionType.Number' })}
        disabled={disabled}
        error={hasError}
        helperText={error}
        type="number"
        size="small"
        onChange={(): void => {
          if (hasError) clearErrors(`${requestItem.id}`)
        }}
        inputProps={{
          step: 'any',
        }}
        InputProps={{
          endAdornment: requestItem.unit && <InputAdornment position="end">{requestItem.unit.symbol}</InputAdornment>,
        }}
        InputLabelProps={{
          shrink: hasAppliedSuggestion ? true : undefined,
        }}
        StackProps={{ sx: { width: '50%' } }}
      />
      <DeviationIndicator
        selectedValue={selectedValue}
        unitSymbol={requestItem.unit?.symbol}
        answersToThisQuestion={answersToThisQuestion}
      />
    </Stack>
  )
}

export default NumberQuestionFieldWithDeviation
